import { makeStyles } from "tss-react/mui";

export const useErrorNotificationStyles = makeStyles()(theme => ({
    notificationContainer: {
        padding: theme.spacing(3, 0),
        minHeight: theme.spacing(15),
    },
}));
